import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { Link } from '../../components/Link';
import { LazyImage } from '../../components/LazyImage';
import { FullScreenImagePreviewTrigger } from '../../components/FullScreenImagePreview';
import { pagePreviewSrc } from '../../lib/pagePreviewSrc';
import type { CategoryPages } from './types';

// The page thumbnail: image + classification label + score. The sizing /
// tinting wrapper is supplied by the layout (flow vs stacked) so this stays
// position-agnostic and shared between both.
export function PagePreviewThumb({
  page,
  category,
  resize,
}: {
  page: CategoryPages[number];
  category: string | undefined;
  resize: string;
}) {
  return (
    <>
      <div className="aspect-3/4 group relative transition-transform duration-200 hover:scale-105">
        <Link to={`/document-pages/${page.id}`}>
          <LazyImage src={pagePreviewSrc(page.id, { resize })} className="w-full h-full" />
        </Link>
        <FullScreenImagePreviewTrigger pageId={page.id} />
      </div>
      <Link
        to={`/document-pages/${page.id}`}
        className={twMerge(
          clsx('text-xs text-gray-500 dark:text-zinc-400 truncate text-center font-bold block', {
            'text-red-500 dark:text-red-400': page.classificationCategory !== category,
          }),
        )}
      >
        {page.classificationCategory}
      </Link>
      <div className="text-xs text-gray-500 dark:text-zinc-400 truncate text-center">
        {(page.classificationScore * 100).toFixed(2)}%
      </div>
    </>
  );
}
